export default __webpack_public_path__ + "static/media/ubiforecast-summary2.2ab8d35d.png";